export class Priveleges{
    public static readonly READ="READ";
    public static readonly WRITE="WRITE";
    public static readonly DOWNLOAD="DOWNLOAD";
}